import React, { useState } from 'react';
import classnames from 'classnames';
import { CategoryLink } from '../form-elements/Link';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { categoryUrlSelector } from '../../../modules/selectors/url';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { useHistory } from 'react-router-dom';
import { useOfferCategory } from '../../hooks/useOfferCategory';

function ShopMenuList({ className = 'uk-nav uk-nav-default uk-nav-parent-icon', 'data-uk-nav': dataUkNav, categories, closeSidebar }) {
    const { hasOfferCategory, offerCategory } = useOfferCategory(categories);
    const categoryUrl = useSelector(categoryUrlSelector);
    const markenStandort = useSelector(markenStandortSelector);
    const [activeCategory, setActiveCategory] = useState(null);
    const [activeSubCategory, setActiveSubCategory] = useState(null);
    const history = useHistory();
    const isLinkActive = category => {
        return category.url === categoryUrl || category?.subCategories?.find(subCategory => subCategory.url === categoryUrl);
    };

    const isActiveCategory = category => {
        return activeCategory === category._id
    }

    const isActiveSubCategory = category => {
        return activeSubCategory === category._id
    }

    const toggleCategory = (e, categoryId) => {
        e.preventDefault();
        e.stopPropagation();
        setActiveCategory((oldState) => {
            const nextCategoryId = oldState === categoryId ? null : categoryId;
            setActiveSubCategory(null);
            return nextCategoryId;
        });
    };

    const toggleSubCategory = (e, subCategoryId) => {
        e.preventDefault();
        e.stopPropagation();
        setActiveSubCategory(oldState => (oldState === subCategoryId ? null : subCategoryId));
    };

    const handleToggleKeyPress = (e, toggleFn) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            toggleFn(e);
        }
    };

    return (
        <ul className={className} data-uk-nav={dataUkNav}>
            {hasOfferCategory &&
                <li key={offerCategory._id} className={classnames({ 'uk-parent': false, 'uk-active': isLinkActive(offerCategory) })} onClick={closeSidebar}>
                    <strong>
                        <CategoryLink category={offerCategory} className="uk-text-bold strong-text">{offerCategory.title}
                        </CategoryLink>
                    </strong>
                </li>
            }
            {categories && categories?.length > 0 && categories.filter(category => {
                return !category.subCategories.every(subCategory => {
                    return markenStandort.categoryBlacklist.map(cat => String(cat._id)).includes(String(subCategory._id))
                })
            }).map(category => {
                const hasSubCategories = category.subCategories.length >= 1;
                return (
                    <li
                        key={category._id}
                        className={classnames({
                            'uk-parent': hasSubCategories,
                            'uk-active': isLinkActive(category),
                        })}
                        id={`${category.url}-tab`}
                    >
                        {hasSubCategories ? (
                            <div className="category_button">
                                <span onClick={closeSidebar}>
                                    <CategoryLink
                                        category={category}
                                        className={classnames('strong-text', {
                                            'mainCategory-active': isActiveCategory(category) && !activeSubCategory,
                                        })}
                                    >
                                        {category.title}
                                    </CategoryLink>
                                </span>
                                <span
                                    role="button"
                                    tabIndex={0}
                                    aria-expanded={isActiveCategory(category)}
                                    aria-controls={`${category.url}-subcategories`}
                                    aria-label={`${category.title} ${isActiveCategory(category) ? 'einklappen' : 'ausklappen'}`}
                                    uk-icon={isActiveCategory(category) ? 'chevron-down' : 'chevron-left'}
                                    onClick={(e) => toggleCategory(e, category._id)}
                                    onKeyDown={(e) => handleToggleKeyPress(e, (event) => toggleCategory(event, category._id))}
                                />
                            </div>
                        ) : (
                            <span onClick={closeSidebar}>
                                <CategoryLink category={category} className="strong-text">{category.title}</CategoryLink>
                            </span>
                        )}
                        {hasSubCategories && isActiveCategory(category) && (
                            <ul className="uk-nav-sub" id={`${category.url}-subcategories`} role="tabpanel" aria-labelledby={`${category.url}-tab`}>
                                {_.sortBy(category.subCategories, ['title']).map((subCategory, index) => {
                                    const hasSubSubCategories = subCategory.subCategories.length >= 1;

                                    return (
                                        <li
                                            key={index}
                                            id={`${subCategory.url}-tab`}
                                            className={classnames({
                                                'uk-parent': hasSubSubCategories,
                                                'uk-active': subCategory.url === categoryUrl,
                                            })}
                                        >
                                            {hasSubSubCategories ? (
                                                <>
                                                    <div className="category_button">
                                                        <span onClick={closeSidebar}>
                                                            <CategoryLink
                                                                category={subCategory}
                                                                className={classnames('strong-text', {
                                                                    'subcategory-active': isActiveCategory(category) && !isActiveSubCategory(subCategory),
                                                                    'sub-subcategory-active': isActiveSubCategory(subCategory),
                                                                })}
                                                            >
                                                                {subCategory.title}
                                                            </CategoryLink>
                                                        </span>
                                                        <span
                                                            role="button"
                                                            tabIndex={0}
                                                            aria-expanded={isActiveSubCategory(subCategory)}
                                                            aria-controls={`${subCategory.url}-subSubcategories`}
                                                            aria-label={`${subCategory.title} ${isActiveSubCategory(subCategory) ? 'einklappen' : 'ausklappen'}`}
                                                            uk-icon={
                                                                isActiveSubCategory(subCategory) ? 'chevron-down' : 'chevron-left'
                                                            }
                                                            onClick={(e) => toggleSubCategory(e, subCategory._id)}
                                                            onKeyDown={(e) => handleToggleKeyPress(e, (event) => toggleSubCategory(event, subCategory._id))}
                                                        />
                                                    </div>

                                                    {isActiveSubCategory(subCategory) && (
                                                        <ul
                                                            className="uk-nav-sub"
                                                            id={`${subCategory.url}-subSubcategories`}
                                                            role="tabpanel"
                                                            aria-labelledby={`${subCategory.url}-tab`}
                                                        >
                                                            <li
                                                                className={classnames({
                                                                    'uk-parent': subCategory,
                                                                    'uk-active': subCategory.url === categoryUrl,
                                                                })}
                                                                onClick={closeSidebar}
                                                            >
                                                            </li>
                                                            {_.sortBy(subCategory.subCategories, ['title']).map(
                                                                (subSubCategory, subIndex) => (
                                                                    <li
                                                                        key={subIndex}
                                                                        onClick={closeSidebar}
                                                                        onKeyPress={() => {
                                                                            closeSidebar();
                                                                            history.push(`${subSubCategory.url}`);
                                                                        }}
                                                                        className={classnames({
                                                                            'uk-parent': subCategory,
                                                                            'uk-active': subSubCategory.url === categoryUrl,
                                                                        })}
                                                                    >
                                                                        <CategoryLink category={subSubCategory} className="strong-text">
                                                                            {subSubCategory.title}
                                                                        </CategoryLink>
                                                                    </li>
                                                                )
                                                            )}
                                                        </ul>
                                                    )}
                                                </>
                                            ) : (
                                                <span onClick={closeSidebar}>
                                                    <CategoryLink category={subCategory} className="strong-text">
                                                        {subCategory.title}
                                                    </CategoryLink>
                                                </span>
                                            )}
                                        </li>
                                    )
                                })}
                            </ul>
                        )}
                    </li>
                );
            })}
        </ul>
    );
}

export default ShopMenuList;
